import {
  getMethod,
  postMethod,
  patchMethod,
  deleteMethod,
} from '../../api/methods'
import API_ROUTES from '../../api/routes'
import { apiParams } from '../../utils'

const PENDING_ACTIONS_REFRESH_EVENT = 'pending-actions-refresh'

const notifyPendingActionsRefresh = jobType => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(
    new CustomEvent(PENDING_ACTIONS_REFRESH_EVENT, {
      detail: { jobType },
    }),
  )
}

const {
  GET_JOB_LIST,
  GET_PENDING_ACTIONS_JOB_LIST,
  SEARCH_JOB_LIST,
  GET_ERROR_CODE,
  GET_JOB_DETAILS,
  JOBS_UPDATE,
  GET_EQUIPMENT,
  SEARCH_EQUIPMENT,
  ADD_ERROR_CODE,
  GET_REPORT,
  SHARE_REPORT,
  UPDATE_REPORT,
  GET_IMAGE_FILE,
  GET_SCRAP_LIST,
  GET_JOB_FOR_SCRAP_LIST,
  GET_ALL_CATEGORY,
  QUICK_EDIT,
  UPDATE_SCRAP_CATEGORY,
  GET_GEO_TAG,
  GET_MACHINE_FOUNDRY,
  GET_PART_SCRAP,
  GET_OCR_DATA,
  JOB_EDIT_LOG,
  GET_VEHICLE_MODEL_LIST,
  ADD_VEHICLE_MODEL,
  SEARCH_VEHICLE_MODEL_LIST,
  GET_JOB_SCRAP,
  BULK_UPLOAD,
  UPLOAD_EXCEL,
  GET_BULK_UPLOAD_LIST,
  SINGLE_BULK_UPLOAD,
  USER_BATCH_NUMBER,
  BATCH_NUMBER,
  GET_ELV_LIST,
  GET_PREVIOUS_JOB,
  PART_NUMBER,
  DOWNLOAD_TEMPLATE,
  GET_FILE_UPLOAD_DETAILS,
  GET_PART_CATEGORY,
  INVOICE_NUMBER_VALIDATION,
  PAYMENT_FORM_GENERATION,
  GET_SEARCH_INVENTORY,
} = API_ROUTES

const getJobListApi = async ({ params }) => {
  const response = await getMethod(GET_JOB_LIST({ params }))
  return response?.data
}

const getPendingActionsJobListApi = async ({ pageNo = 1, params = '' }) => {
  const response = await getMethod(
    GET_PENDING_ACTIONS_JOB_LIST({ pageNo, params }),
  )
  return response?.data
}

const searchJobListApi = async ({ params }) => {
  const response = await getMethod(SEARCH_JOB_LIST({ params }))
  return response?.data
}

const getErrorCodeApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_ERROR_CODE({ pageNo, params }))
  return response?.data
}

const addErrorCodeApi = async ({ payload }) => {
  const response = await postMethod(ADD_ERROR_CODE, payload)
  return response?.data
}

const editErrorCodeApi = async ({ payload }) => {
  const response = await patchMethod(ADD_ERROR_CODE, payload)
  return response?.data
}

const getJobDetailApi = async ({ params }) => {
  const response = await getMethod(GET_JOB_DETAILS({ params }))
  return response?.data
}

const addJobPostApi = async ({ payload }) => {
  const response = await postMethod(JOBS_UPDATE, payload)
  return response
}

const updateJobPatchApi = async ({ payload }) => {
  const response = await patchMethod(JOBS_UPDATE, payload)
  return response
}

const removeEquipmentApi = async ({ payload }) => {
  const response = await deleteMethod(JOBS_UPDATE, { data: payload })
  return response?.data
}

const getEquipmentApi = async ({ params }) => {
  const response = await getMethod(GET_EQUIPMENT({ params }))
  return response?.data
}

const searchEquipmentApi = async ({ params }) => {
  const response = await getMethod(SEARCH_EQUIPMENT({ params }))
  return response?.data
}

const getReportApi = async ({ jobId, jobType }) => {
  const response = await getMethod(GET_REPORT({ jobId, jobType }))
  return response?.data
}

const shareCertificateApi = async ({ payload }) => {
  const response = await postMethod(SHARE_REPORT, payload)
  return response
}

const updateReportApi = async ({ payload }) => {
  const response = await postMethod(UPDATE_REPORT, payload)
  return response?.data
}

const getImageFileApi = async ({ params, payload }) => {
  const response = await postMethod(GET_IMAGE_FILE({ params }), payload)
  return response?.data
}
const deleteImageFileApi = async ({ params }) => {
  const response = await deleteMethod(GET_IMAGE_FILE({ params }))
  return response?.data
}

const scrapListAPI = async ({ params }) => {
  const response = await getMethod(GET_SCRAP_LIST({ params }))
  return response?.data
}

const jobForScrapListAPI = async ({ params }) => {
  const response = await getMethod(GET_JOB_FOR_SCRAP_LIST({ params }))
  return response?.data
}

const getAllCategoryListAPI = async () => {
  const response = await getMethod(GET_ALL_CATEGORY)
  return response?.data
}

const quickEditAPI = async ({ payload }) => {
  const response = await patchMethod(QUICK_EDIT, payload)
  return response
}

const updateScrapCategoryApi = async ({ params }) => {
  const response = await patchMethod(
    UPDATE_SCRAP_CATEGORY({ params: apiParams({ params }) }),
    {},
  )
  return response
}

const getGeoTagDataApi = async ({ params }) => {
  const response = await getMethod(
    GET_GEO_TAG({ params: apiParams({ params }) }),
  )
  return response?.data
}

const getMachineFoundryScrapApi = async ({ params }) => {
  const response = await getMethod(
    GET_MACHINE_FOUNDRY({ params: apiParams({ params }) }),
  )
  return response?.data
}

const getPartScrapApi = async ({ params, pageNo }) => {
  const response = await getMethod(
    GET_PART_SCRAP({ params: apiParams({ params, pageNo }) }),
  )
  return response?.data
}

const getOcrDataApi = async ({ payload }) => {
  const response = await postMethod(GET_OCR_DATA, payload)
  return response?.data
}

const getJobEditLogApi = async ({ params }) => {
  const response = await getMethod(
    JOB_EDIT_LOG({ params: apiParams({ params }) }),
  )
  return response?.data
}

const postJobEditLogApi = async ({ payload }) => {
  const response = await postMethod(JOB_EDIT_LOG(), payload)
  return response?.data
}

const patchJobEditLogApi = async ({ payload }) => {
  const response = await patchMethod(JOB_EDIT_LOG(), payload)
  return response?.data
}

const getVehicleModelListApi = async ({ params, pageNo }) => {
  const response = await getMethod(
    GET_VEHICLE_MODEL_LIST({ params: apiParams({ params, pageNo }) }),
  )
  return response?.data
}

const addVehicleModelApi = async ({ payload }) => {
  const response = await postMethod(ADD_VEHICLE_MODEL, payload)
  return response?.data
}

const searchVehicleModelListApi = async ({ params, pageNo }) => {
  const response = await getMethod(
    SEARCH_VEHICLE_MODEL_LIST({ params: apiParams({ params, pageNo }) }),
  )
  return response?.data
}

const getJobScrapAPI = async ({ params }) => {
  const response = await getMethod(
    GET_JOB_SCRAP({ params: apiParams({ params }) }),
  )
  return response?.data
}

const bulkUploadApi = async ({ payload }) => {
  const response = await postMethod(BULK_UPLOAD, payload)
  return response?.data
}

const uploadExcelApi = async ({ params }) => {
  const response = await postMethod(
    UPLOAD_EXCEL({ params: apiParams({ params }) }),
  )
  return response?.data
}

const getBulkUploadListApi = async ({ params, pageNo }) => {
  const response = await getMethod(
    GET_BULK_UPLOAD_LIST({ params: apiParams({ params, pageNo }) }),
  )
  return response?.data
}

const getSingleBulkUploadApi = async ({ params, pageNo }) => {
  const response = await getMethod(
    SINGLE_BULK_UPLOAD({ params: apiParams({ params, pageNo }) }),
  )
  return response?.data
}

const userBatchNumberCheckApi = async ({ params }) => {
  const response = await getMethod(USER_BATCH_NUMBER, {
    params,
    hideErrorPopup: true,
  })
  return response?.data
}

const bachNumberCheckApi = async ({ params }) => {
  const response = await getMethod(BATCH_NUMBER, {
    params,
    hideErrorPopup: true,
  })
  return response?.data
}

const getELVListApi = async ({ params }) => {
  const response = await getMethod(GET_ELV_LIST, { params })
  return response?.data
}
const getPreviousJobApi = async ({ params }) => {
  const response = await getMethod(GET_PREVIOUS_JOB, { params })
  return response?.data
}
const getPartNumberListApi = async ({ params, pageNo }) => {
  const response = await getMethod(PART_NUMBER({ pageNo }), { params })
  return response?.data
}
const AddPartNumberApi = async ({ payload }) => {
  const response = await postMethod(PART_NUMBER(), payload)
  return response?.data
}

const downloadTemplateApi = async ({ params }) => {
  const response = await getMethod(
    DOWNLOAD_TEMPLATE({ params: apiParams({ params }) }),
  )
  return response?.data
}

const getFileUploadDetailsApi = async ({ pageNo, params }) => {
  const response = await getMethod(GET_FILE_UPLOAD_DETAILS({ pageNo }), {
    params,
  })
  return response?.data
}

const getCategoriesListApi = async ({ params }) => {
  const response = await getMethod(GET_PART_CATEGORY, { params })
  return response?.data
}

const validateInvoiceNumberApi = async ({ params }) => {
  const response = await getMethod(INVOICE_NUMBER_VALIDATION, {
    params,
  })
  return response
}

const paymentGenerationApi = async ({ jobId, updatedChanges = [] }) => {
  const response = await postMethod(`${PAYMENT_FORM_GENERATION}`, {
    jobId,
    updatedChanges,
  })
  return response?.data
}

const getSearchInventoryApi = async ({ params }) => {
  const response = await getMethod(GET_SEARCH_INVENTORY({ params }))
  return response?.data
}

export {
  PENDING_ACTIONS_REFRESH_EVENT,
  notifyPendingActionsRefresh,
  getJobListApi,
  getPendingActionsJobListApi,
  searchJobListApi,
  getJobDetailApi,
  getErrorCodeApi,
  addErrorCodeApi,
  editErrorCodeApi,
  addJobPostApi,
  updateJobPatchApi,
  getEquipmentApi,
  searchEquipmentApi,
  getReportApi,
  shareCertificateApi,
  updateReportApi,
  getImageFileApi,
  deleteImageFileApi,
  removeEquipmentApi,
  scrapListAPI,
  jobForScrapListAPI,
  getAllCategoryListAPI,
  quickEditAPI,
  updateScrapCategoryApi,
  getGeoTagDataApi,
  getMachineFoundryScrapApi,
  getPartScrapApi,
  getOcrDataApi,
  getJobEditLogApi,
  postJobEditLogApi,
  patchJobEditLogApi,
  getVehicleModelListApi,
  searchVehicleModelListApi,
  getJobScrapAPI,
  bulkUploadApi,
  uploadExcelApi,
  getBulkUploadListApi,
  getSingleBulkUploadApi,
  userBatchNumberCheckApi,
  bachNumberCheckApi,
  getELVListApi,
  getPreviousJobApi,
  getPartNumberListApi,
  AddPartNumberApi,
  downloadTemplateApi,
  getFileUploadDetailsApi,
  addVehicleModelApi,
  getCategoriesListApi,
  validateInvoiceNumberApi,
  paymentGenerationApi,
  getSearchInventoryApi,
}
